import styled from 'styled-components';

export const Base = styled.button<{ active?: boolean; disabled?: boolean }>`
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 12px;
	padding: 12px 16px;
	border: none;
	border-radius: 8px;
	background: ${({ theme, active }) => (active ? `${theme.blue[500]}14` : 'transparent')};
	color: ${({ theme }) => theme.gray[1000]};
	text-align: left;
	width: 100%;
	opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: 3px;
		height: 100%;
		background: ${({ theme }) =>
			`linear-gradient(180deg, ${theme.blue[500]} 0%, ${theme.blue[700]} 100%)`};
		opacity: ${({ active }) => (active ? 1 : 0)};
		transition: opacity 0.2s ease;
		border-radius: 8px 0 0 8px;
	}

	&:hover:not(:disabled) {
		background-color: ${({ theme, active }) =>
			active ? `${theme.blue[500]}1F` : theme.gray[200]};
		box-shadow: ${({ theme, active }) =>
			active ? `0 2px 8px ${theme.blue[500]}1A` : `0 4px 12px ${theme.gray[1000]}33`};
	}
`;

export const Info = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 4px;
	flex: 1;
`;

export const Label = styled.div`
	font-size: 13px;
	font-weight: 600;
`;

export const Description = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
`;
